import Events from '../../../events/Events';
import EventDispatcher from '../../../events/EventDispatcher';
import Tools from '../../../tools/Tools';
import Callbacks from './Validate/Callbacks';
import Utils from './Validate/Utils';

export default class ValidateCheckout{

    /**
     * Validate a value based on a type.
     *
     * @param mixed value The value to evaluate.
     * @param string type The type of the validation.
     * @return boolean True if the value pass the validation type
     */
    check(value, type){

        switch(type){

            case 'name': return Utils.validateName(value);
            case 'phone': return Utils.validatePhone(value);
            case 'zipcode': return Utils.validateZipCode(value);
            case 'email': return Utils.validateEmail(value);
            case 'number': return Utils.validateNumber(value);
            case 'default': return true;
            default: return false;
        }
    }

    constructor(view){
        this.view           = view.parentNode;
        this.inputs_invalid = view.querySelector('.inputs_invalid');
        this.terms          = this.view.terms;
        this.note          = this.view.note;
        this.sending        = false;
        this.formMessage    = document.querySelector('.formMessage');

        this.formValidate = {
            informations : {
                firstname: { view: this.view.firstname, notEmpty: Utils.validateNotEmpty(this.view.firstname.value), required: true, type: 'name', valid: false, callback: Callbacks.nameCallback}
                ,name: { view: this.view.lastname, notEmpty: Utils.validateNotEmpty(this.view.lastname.value), required: true, type: 'name', valid: false, callback: Callbacks.nameCallback}
                ,company: { view: this.view.company, notEmpty: Utils.validateNotEmpty(this.view.company.value), required: false, type: 'default', valid: false}
                ,country: { view: this.view.country, notEmpty: Utils.validateNotEmpty(this.view.country.value), required: true, type: 'default', valid: false}
                ,province: { view: this.view.province, notEmpty: Utils.validateNotEmpty(this.view.province.value), required: true, type: 'default', valid: false}
                ,address: { view: this.view.address, notEmpty: Utils.validateNotEmpty(this.view.address.value), required: true, type: 'default', valid: false}
                ,app: { view: this.view.app, notEmpty: Utils.validateNotEmpty(this.view.app.value), required: false, type: 'default', valid: false}
                ,city: { view: this.view.city_checkout, notEmpty: Utils.validateNotEmpty(this.view.city_checkout.value), required: true, type: 'default', valid: false}
                ,zipcode: { view: this.view.zipcode, notEmpty: Utils.validateNotEmpty(this.view.zipcode.value), required: true, type: 'default', valid: false}
                // ,zipcode: { view: this.view.zipcode, notEmpty: Utils.validateNotEmpty(this.view.zipcode.value), required: true, type: 'zipcode', valid: false, callback: Callbacks.zipCodeCallback}
                ,phone: { view: this.view.phone, notEmpty: Utils.validateNotEmpty(this.view.phone.value), required: true, type: 'phone', valid: false, callback: Callbacks.phoneCallback}
                ,email: { view: this.view.email, notEmpty: Utils.validateNotEmpty(this.view.email.value), required: true, type: 'email', valid: false}
            }
            ,newsletter: false
            ,terms: false
            ,note: false
        };

        console.log('ValidateCheckout :: init', this.formValidate);
    }

    validate(){

        Tools.scrollTo(0,$(document.querySelector('.container')).offset().top - 40);

        this.invalids = [];

        this.validateInputs();
        this.validateTerms();
        this.validateNote();

        //no errors, all gucci
        if(this.invalids.length == 0){
            document.querySelector('.container').classList.add('load');
            this.inputs_invalid.classList.add('hidden');

            this.form = {
                firstname: this.view.firstname.value
                ,lastname: this.view.lastname.value
                ,company: this.view.company.value
                ,country: this.view.country.value
                ,province: this.view.province.value
                ,address: this.view.address.value
                ,apartement: this.view.app.value
                ,city: this.view.city_checkout.value
                ,zipcode: this.view.zipcode.value
                ,phone: this.view.phone.value
                ,email: this.view.email.value
                ,newsletter: this.formValidate.newsletter
                ,terms: this.formValidate.terms
            }
            EventDispatcher.trigger(window, Events.Checkout.SUCCESS, true, true, this.form);

        }
        else {
            this.inputs_invalid.classList.remove('hidden');
            this.formMessage.classList.add('hidden');
        }

        console.log('ValidateCheckout :: submit', this.formValidate);
    }

    validateInputs(){
        console.log("Validate :: Inputs");

        //Loop through all inputs
        Object.keys(this.formValidate['informations']).forEach(prop =>{
            let current = this.formValidate['informations'][prop];
            if (!current.view) return;

            current.notEmpty = Utils.validateNotEmpty(current.view.value);

            // Check if is not required
            if(!current.required) {

                current.valid = true;

            }else{

                // Check if is not empty
                if(!current.notEmpty) current.valid = false;
                else{
                    // Check if is valid
                    if(!this.check(current.view.value, current.type)) current.valid = false;
                    else current.valid = true;

                    // Check if there's a callback
                    if(typeof current.callback === 'function'){
                        current.callback(current.view, current.view.value, current.valid);
                    }
                }
            }

            if(!current.valid) {

                current.view.parentNode.classList.add('invalid');
                this.invalids.push(current.view.id);

            }else current.view.parentNode.classList.remove('invalid');
        });
    }

    validateTerms(){
        console.log("Validate :: Terms");
        if(!this.formValidate.terms) {
            this.terms.parentNode.classList.add('invalid');
            this.invalids.push(this.terms.id);
        }
        else this.terms.parentNode.classList.remove('invalid');
    }

    validateNote(){
        console.log("Validate :: Note");
        if(!this.formValidate.note) {
            this.note.parentNode.classList.add('invalid');
            this.invalids.push(this.note.id);
        }
        else this.note.parentNode.classList.remove('invalid');
    }
}